// import external dependencies
/* eslint-disable */
import "jquery";
import "./autoload/_bootstrap.js";
import "sticky-kit/dist/sticky-kit";
import accordionAction from "./modules/accordeon";
import loadMoreScroll from "./modules/load-more-scroll";
import "slick-carousel";
import "jquery-match-height";
import prices from "./modules/prices";
import customDropdownSelect from './modules/customDropdownSelect';
import smScroll from "./modules/smScroll";
import ShipCalc from "./modules/shipCalc";
import ROICalc from "./modules/roiCalc";
import ROICalcExtended from "./modules/roiCalcExtended";
import searchBar from "./modules/search-bar";
import LDMCalculator from "./modules/ldmCalc";
import videos from "./modules/videos";
import customSelect from "./modules/customSelect";
import pricesDropDown from "./modules/pricesDropdown";
import pricePlanCalculator from "./modules/ppCalc";
import shippingSelect from "./modules/shippingSelect";
import ShippingResults from "./modules/shipping-results";
import SavingCalc from "./modules/costSavingsCalc";
import HeroDemoForm from "./modules/HeroDemoForm";

async function initRoiCalc(idPage, indFlex, el) {
    const form = el.querySelector('#roi-form');
    const submit = el.querySelector('#roi-submit');
    const where = el.querySelector(`#where-${idPage}${indFlex}`);
    if (!form || !submit || !where) return;

    form.addEventListener('submit', (e) => e.preventDefault());
    submit.setAttribute('disabled', '');

    let response = await fetch(`${themeVars.home}/wp-json/calc_data/v2/data?id_page=${idPage}&index_flexible_array=${indFlex}`, {
        headers: {
            "Content-type": "application/json;charset=UTF-8"
        }
    });
    if (response.ok) {
        let json = await response.json();
        if (!json || !json[where.value] || !Array.isArray(json[where.value].table_price)
            || !json[where.value].table_price.length) {
            console.error('ROI calculator: price data is unavailable.', {idPage, indFlex});
            return;
        }
        const roi = new ROICalc();

        roi.init(
            el.querySelector('#curWeight'),
            el.querySelector('#week'),
            where,
            el.querySelector('#average'),
            form,
            submit,
            el.querySelector('.results'),
            el.querySelector('#providers-price'),
            el.querySelector('#sendify-price'),
            el.querySelector('#save'),
            json,
        );

        roi.setCurrentWeight = roi.getCurrentWeight;
        roi.setOutput(roi.weightBlock, roi.curWeight);
        roi.hide(roi.resultsBlock);

        roi.form.addEventListener('submit', (e) => {
            e.preventDefault();
            roi.setProviderPrice = roi.getProviderPrice;
            roi.setSendifyPrice = roi.getSendifyPrice;
            if (el.classList.contains('percentages')) {
                roi.setSaved = roi.getSaved;
            } else {
                roi.setSaved = roi.getSavedCurrency;
            }
            if (roi.sendifyPrice && roi.providerPrice && roi.saved) {
                roi.setOutput(roi.providerPriceBlock, roi.providerPrice)
                roi.setOutput(roi.sendifyPriceBlock, roi.sendifyPrice)
                roi.setOutput(roi.saveBlock, roi.saved)
                roi.show(roi.resultsBlock);
                roi.setValue(roi.submit, roi.submit.dataset.recalculate);
                roi.submit.setAttribute('disabled', '');
            } else {
                console.error('error');
            }
        })
        roi.form.addEventListener('input', (e) => {
            roi.setCurrentWeight = roi.getCurrentWeight;
            roi.setOutput(roi.weightBlock, roi.curWeight);
            roi.clearResults();
        });

        $(`#where-${idPage}${indFlex}`).on("change", () => {
            roi.setAverage = roi.getAverage;
            roi.setCurrentWeight = roi.getCurrentWeight;
            roi.setOutput(roi.weightBlock, roi.curWeight);
            roi.clearResults();
        });
        submit.removeAttribute('disabled');

    } else {
        console.error('error');
    }
}

async function initRoiCalcExtended(idPage, indFlex, el) {
    let response = await fetch(`${themeVars.home}/wp-json/se_roi_calc_extended/v2/data`, {
        headers: {
            "Content-type": "application/json;charset=UTF-8"
        }
    });
    if (response.ok) {
        let json = await response.json();
        const roiSE = new ROICalcExtended();

        roiSE.init(
            el.querySelector(`#curWeight-parcel-${idPage}${indFlex}`),
            el.querySelector(`#curWeight-pallet-${idPage}${indFlex}`),
            el.querySelector(`#month-parcel-${idPage}${indFlex}`),
            el.querySelector(`#month-pallet-${idPage}${indFlex}`),
            el.querySelector(`#where-${idPage}${indFlex}`),
            el.querySelector(`#average-parcel-${idPage}${indFlex}`),
            el.querySelector(`#average-pallet-${idPage}${indFlex}`),
            el.querySelector('#roi-form-extended'),
            el.querySelector('#roi-form-extended-submit'),
            el.querySelector('.results'),
            el.querySelector('#providers-price'),
            el.querySelector('#providers-price-plus'),
            el.querySelector('#sendify-price'),
            el.querySelector('#sendify-plus-price'),
            el.querySelector('#save-free'),
            el.querySelector('#save-plus'),
            json,
        );

        roiSE.setCurrentWeight = roiSE.getCurrentWeight;
        roiSE.setCurrentWeightPallet = roiSE.getCurrentWeightPallet;
        roiSE.setOutput(roiSE.weightBlock, roiSE.curWeight);
        roiSE.setOutput(roiSE.weightBlockPallet, roiSE.curWeightPallet);
        roiSE.hide(roiSE.resultsBlock);

        roiSE.form.addEventListener('submit', (e) => {
            e.preventDefault();
            roiSE.setProviderPrice = roiSE.getProviderPrice;
            roiSE.setProviderPlusPrice = roiSE.getProviderPlusPrice;
            roiSE.setSendifyPricePlus = roiSE.getSendifyPlusPrice;
            roiSE.setSendifyPrice = roiSE.getSendifyPrice;
            roiSE.setSaved = roiSE.getSaved;
            roiSE.setSavedPlus = roiSE.getSavedPlus;

            if (roiSE.sendifyPrice && roiSE.providerPrice && roiSE.sendifyPricePlus && roiSE.savedPlus && roiSE.saved) {
                roiSE.setOutput(roiSE.providerPriceBlock, roiSE.providerPrice.toLocaleString('sv-SE'))
                roiSE.setOutput(roiSE.providerPricePlusBlock, roiSE.providerPrice.toLocaleString('sv-SE'))
                roiSE.setOutput(roiSE.sendifyPriceBlock, roiSE.sendifyPrice.toLocaleString('sv-SE'))
                roiSE.setOutput(roiSE.sendifyPlusPriceBlock, roiSE.sendifyPricePlus.toLocaleString('sv-SE'))
                roiSE.setOutput(roiSE.saveBlock, roiSE.saved.toLocaleString('sv-SE'))
                roiSE.setOutput(roiSE.saveBlockPlus, roiSE.savedPlus.toLocaleString('sv-SE'))
                roiSE.show(roiSE.resultsBlock);
                roiSE.setValue(roiSE.submit, roiSE.submit.dataset.recalculate);
                roiSE.submit.setAttribute('disabled', '');
            } else {
                console.error('error');
            }
        })

        roiSE.average.addEventListener('input', (e) => {
            roiSE.setCurrentWeight = roiSE.getCurrentWeight;
            roiSE.setOutput(roiSE.weightBlock, roiSE.curWeight);
            roiSE.clearResults();
        });

        roiSE.week.addEventListener('input', (e) => {
            roiSE.setCurrentWeight = roiSE.getCurrentWeight;
            roiSE.setOutput(roiSE.weightBlock, roiSE.curWeight);
            roiSE.clearResults();
        });

        roiSE.averagePallet.addEventListener('input', (e) => {
            roiSE.setCurrentWeightPallet = roiSE.getCurrentWeightPallet;
            roiSE.setOutput(roiSE.weightBlockPallet, roiSE.curWeightPallet);
            roiSE.clearResults();
        });

        roiSE.weekPallet.addEventListener('input', (e) => {
            roiSE.setCurrentWeightPallet = roiSE.getCurrentWeightPallet;
            roiSE.setOutput(roiSE.weightBlockPallet, roiSE.curWeightPallet);
            roiSE.clearResults();
        });

        $(`#where-${idPage}${indFlex}`).on("change", () => {
            roiSE.setAverage = roiSE.getAverage;
            roiSE.setAveragePallet = roiSE.getAveragePallet;
            roiSE.setCurrentWeight = roiSE.getCurrentWeight;
            roiSE.setCurrentWeightPallet = roiSE.getCurrentWeightPallet;
            roiSE.setOutput(roiSE.weightBlock, roiSE.curWeight);
            roiSE.setOutput(roiSE.weightBlockPallet, roiSE.curWeightPallet);
            roiSE.clearResults();
        });


    } else {
        console.error('error');
    }
}

const roiSelector = document.querySelectorAll('.roi-calculator');
const roiSelectorSE = document.querySelectorAll('.roi-calculator-extended');

$(document).ready(() => {

    const dataCompanyForms = document.querySelectorAll('[data-company-form]');
    if(dataCompanyForms.length >= 1) {
        dataCompanyForms.forEach((form) => new HeroDemoForm(form));
    }

    if (roiSelector.length >= 1) {
        roiSelector.forEach(function (el) {
            initRoiCalc(el.getAttribute('data-id-page'), el.getAttribute('data-index-flexible-array'), el)
                .catch(error => console.error('ROI calculator initialization failed:', error));
        });
    }

    if (roiSelectorSE.length >= 1) {
        roiSelectorSE.forEach(function (el) {
            initRoiCalcExtended(el.getAttribute('data-id-page'), el.getAttribute('data-index-flexible-array'), el)
        });
    }

    const ldmCalculatorSections = document.querySelectorAll('.ldm-calculator');
    if (ldmCalculatorSections.length >= 1) {
        ldmCalculatorSections.forEach(section => new LDMCalculator(section));
    }

    const heroSavingsCalculatorSections = document.querySelectorAll('[data-savings-calculator]');
    if (heroSavingsCalculatorSections.length >= 1) {
        heroSavingsCalculatorSections.forEach(section => new SavingCalc(section));
    }

    shippingSelect();
    searchBar();
    customDropdownSelect();
    prices();
    videos();

    if (document.querySelector('select.js-new-custom-select')) {
        customSelect.initAll();
    }
    const pricingPlansSections = document.querySelectorAll('section.pricing-plans');
    if(pricingPlansSections.length > 0) {
        pricingPlansSections.forEach(section => pricesDropDown(section));
    }

    const searchResultsSections = document.querySelectorAll('.hero-offers-with-results');
    if (searchResultsSections.length > 0) {
        searchResultsSections.forEach(section => {
            new ShippingResults(section);
        })
    }

    const shippingCalcSections = document.querySelectorAll('.calculator');
    if(shippingCalcSections.length > 0){
        new ShipCalc('.calculator');
    }

    const loadMore = document.querySelector('.lds-dual-ring');
    if (loadMore) {
        const observerLoadMoreScrollCallback = entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadMoreScroll(entry.target);
                }
            });
        };

        const observerOptions = {
            threshold: 1,
        };

        const observer = new IntersectionObserver(observerLoadMoreScrollCallback, observerOptions);
        observer.observe(loadMore);
    }

    function iOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod',
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    if (iOS()) {
        document.body.classList.add('ios-device');
    }

    $(document).on({
        mouseenter: function () {
            $(this).addClass("animated");
            $(this).bind(
                "webkitAnimationEnd mozAnimationEnd msAnimationEnd oAnimationEnd animationEnd",
                function () {
                    $(this).removeClass("animated");
                }
            );
        }
    }, '.sendify-btn');


    accordionAction();

    const ppSections = document.querySelectorAll('.pp-calculator');
    if (ppSections.length > 0) {
        ppSections.forEach(currentPlanCalculatorSection => pricePlanCalculator(currentPlanCalculatorSection));
    }

    // smooth scroll (Icon Box Section)
    var hashTagActive = "";
    $(".scroll").on("click touchstart", function () {
        if (hashTagActive != this.hash) {
            var dest = 0;
            if (
                $(this.hash).offset().top >
                $(document).height() - $(window).height()
            ) {
                dest = $(document).height() - $(window).height();
            } else {
                dest = $(this.hash).offset().top;
            }
            $("html,body").animate(
                {
                    scrollTop: dest,
                },
                800,
                "swing"
            );
            hashTagActive = this.hash;
        }
        hashTagActive = "";
    });

    smScroll();

    $(".testimonial-slider").slick({
        dots: false,
        arrows: false,
        autoplay: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    //dropdown menu switcher
    if ($(".wpml-ls-sub-menu").is(":visible")) {
        $(".wpml-ls-item-toggle").addClass("is-open");
    } else {
        $(".wpml-ls-item-toggle").removeClass("is-open");
    }
});

$(window).load(function () {
    // table styling
    $('table.wptb-table tr.wptb-row td .wptb-text-container p').each(function () {
        if ($(this).has('a').length > 0 || $(this).has('strong').length > 0 || $(this).has('em').length > 0 || $(this).has('s').length > 0) {
            return;
        } else {
            let text = $(this).text();
            $(this).html(`<span>${text}</span>`);
        }
    });
    $(".old-posts article").matchHeight();
    $(".icon-box__list--item").matchHeight();

    $(".hero-pricing-plans-item__prices").matchHeight();
    $(".hero-pricing-plans-item__body-title").matchHeight();

    //sticky sidebar
    const makeSticky = () => {
        $(".sidebar-info").stick_in_parent({
            offset_top: 230,
        });
    };

    let windowWidth = $(window).width();

    if (windowWidth < 1050) {
        $(".sidebar-info").trigger("sticky_kit:detach");
    } else {
        makeSticky();
    }
    $(".single .textbox").first().addClass('lead-box');
});



// WEBPACK FOOTER //
// ./scripts/main.js